export const defis = [
  {
    key: 'defis-stress',
    title: 'Moins de stress. Plus de',
    titleAccent: 'maîtrise.',
    subtitle: 'Les défis que nous résolvons',
    items: [
      'Vos équipes utilisent des IA grand public sans cadre : données métier exposées à des acteurs étrangers.',
      'Menaces : fuite de données, réutilisation pour l’entraînement, dépendance à des outils extra-européens.',
      'Une IA générique mal adaptée à vos procédures, vos métiers et votre vocabulaire.',
      'Difficile de faire adhérer les équipes et de mesurer les bénéfices réels sans accompagnement.',
    ],
  },
  {
    key: 'defis-engagements',
    title: 'Une IA souveraine, un accompagnement',
    titleAccent: 'continu.',
    subtitle: 'Nos engagements envers vous',
    items: [
      'Une IA hébergée en France, dans une infrastructure française et européenne.',
      'Vos données protégées : ni entraînement, ni réutilisation, ni exploitation commerciale.',
      'Des cas d’usage cadrés et des assistants IA adaptés à vos métiers.',
      'Administration continue 24h/24 et 7j/7 assurée par nos experts.',
    ],
  },
]
